import React from "react";
import { Truck, Shield, Package, Sparkles } from "lucide-react";
import { useLang } from "../lib/i18n";

const COPY = {
  el: [
    { icon: Truck, title: "Δωρεάν Αποστολή", sub: "Σε όλη την Ελλάδα" },
    { icon: Shield, title: "Ασφαλής Πληρωμή", sub: "Αντικαταβολή ή κάρτα" },
    { icon: Package, title: "Premium Συσκευασία", sub: "Με χρυσή κορδέλα" },
    { icon: Sparkles, title: "100% Ελληνικά", sub: "Από τοπικούς παραγωγούς" },
  ],
  en: [
    { icon: Truck, title: "Free Shipping", sub: "Across Greece" },
    { icon: Shield, title: "Secure Payment", sub: "COD or card" },
    { icon: Package, title: "Premium Packaging", sub: "With gold ribbon" },
    { icon: Sparkles, title: "100% Greek", sub: "From local producers" },
  ],
  bg: [
    { icon: Truck, title: "Безплатна доставка", sub: "В цяла Гърция" },
    { icon: Shield, title: "Сигурно плащане", sub: "Наложен платеж / карта" },
    { icon: Package, title: "Premium опаковка", sub: "Със златна панделка" },
    { icon: Sparkles, title: "100% гръцко", sub: "От местни производители" },
  ],
  ru: [
    { icon: Truck, title: "Бесплатная доставка", sub: "По всей Греции" },
    { icon: Shield, title: "Безопасная оплата", sub: "Наличными или картой" },
    { icon: Package, title: "Premium упаковка", sub: "С золотой лентой" },
    { icon: Sparkles, title: "100% греческое", sub: "От местных производителей" },
  ],
};

export const TrustBadges = () => {
  const { lang } = useLang();
  const items = COPY[lang] || COPY.el;

  return (
    <section
      data-testid="trust-badges"
      className="relative py-12 px-6 border-y border-[color:var(--goldenelia-gold)]/15"
    >
      <div className="max-w-6xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-8">
        {items.map((b, i) => {
          const Icon = b.icon;
          return (
            <div
              key={i}
              data-testid={`trust-badge-${i}`}
              className="flex items-center gap-4"
            >
              <div className="w-12 h-12 shrink-0 flex items-center justify-center border border-[color:var(--goldenelia-gold)]/40 text-[color:var(--goldenelia-gold)]">
                <Icon size={22} strokeWidth={1.4} />
              </div>
              <div className="leading-tight">
                <p className="font-display text-[11px] tracking-[0.25em] uppercase text-[color:var(--goldenelia-gold-bright)]">
                  {b.title}
                </p>
                <p className="font-body text-xs text-[color:var(--goldenelia-cream)]/65 mt-1">
                  {b.sub}
                </p>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default TrustBadges;
